import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import React, {useState} from "react";
import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/`
})
const CheckoutForm = (props) => {
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');
  const stripe = useStripe();
  const elements = useElements();
// Handle real-time validation errors from the CardElement.
const handleChange = (event) => {
  if (event.error) {
    setError(event.error.message);
  } else {
    setError(null);
  }
}
// Handle form submission.
const handleSubmit = async (event) => {
    event.preventDefault();
    const card = elements.getElement(CardElement);
    const {paymentMethod, error} = await stripe.createPaymentMethod({
      type: 'card',
      card: card
  });
  let data = new FormData();
  data.append('email', email);
  data.append('payment_method_id', paymentMethod.id);
  data.append('price', props.data.price*100);
  console.log(paymentMethod.id)
  return api.post('payments/save-stripe-info/',data,{ headers: {"Content-type": "application/json" } })
  .then(response => {
    console.log(response.data);
    if(response.data.message === 'Success'){
      props.onchange('stripe');
      alert("Payment Successful!")
    }
    else{
      alert('Can not charge payment! Try Again Later')
    }
  }).catch(error => {
    alert('Payment Unsuccessful! Try Again Later')
  })
}
const CARD_ELEMENT_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "rgb(57, 167, 240)",
      color: "rgb(130, 57, 240)",
      fontSize: "16px",
      fontFamily: '"Open Sans", sans-serif',
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#CFD7DF"
      }
    },
    invalid: {
      color: "#e5424d",
      ":focus": {
        color: "#303238"
      }
    }
  }
};
return (
  <form onSubmit={handleSubmit} className="stripe-form">
    <div className="input-group input-group-sm mb-3">
      <div className="input-group-prepend">
        <span className="input-group-text bg-primary" style={{width:'55px'}} ><i className='fa fa-envelope' style={{marginLeft: '9px'}}/></span>
      </div>
      <input type="email" className="form-control" id="email" name="name" placeholder="Enter your Email Address" required value={email} onChange={(event) => { setEmail(event.target.value)}} />
    </div>
    
    <label style={{fontFamily:'fantasy', fontSize:'17px'}}>Credit or debit card Number</label> 
    <CardElement id="card-element" onChange={handleChange} options={CARD_ELEMENT_OPTIONS} />
    <div className="card-errors" role="alert">{error}</div>
    
    <button type="submit" className="btn btn-primary ms-4 me-2 mt-2" style={{width:'150px', fontSize:'12px', float:'right'}}>
      Submit Payment
    </button>
  </form>
 );
};
export default CheckoutForm;